import {Route, Routes} from "react-router-dom";
import TimekeepingFormula from "./timesheet-formula/Index";
import ShiftRouter from "./shift/Router";
import OnLeaveConfigList from "./annual-leave";
import LeaveSettingForm from "./annual-leave/form/Form";
import TimeKeepingSetting from "./timekeeping-settings";
import CompensatoryLeaveSettingForm from "./compensatory-leave";
import Error404 from "../../../common/error/Error404";
import AttendanceLocations from "./locations";
import AddLocation from "./locations/add";
const TimeKeepingSettingRouter = props => {

    return (
        <Routes>

            <Route path="/">
                <Route path="timesheet-formula" element={<TimekeepingFormula/>}/>
                <Route path="shift-work/*" element={<ShiftRouter/>}/>
                <Route path="annual-leave">
                    <Route index element={<OnLeaveConfigList/>}/>
                    <Route path={"add"} element={<LeaveSettingForm/>}/>
                    <Route path={"update/:id"} element={<LeaveSettingForm/>}/>
                </Route>

                <Route path="timekeeping-settings" element={<TimeKeepingSetting/>}/>
                <Route path="attendance-locations" >
                    <Route index element={<AttendanceLocations/>}/>
                    <Route path={"add"} element={<AddLocation/>}/>
                    <Route path={"update/:id"} element={<AddLocation/>}/>
                </Route>
                <Route path="compensatory-leave" element={<CompensatoryLeaveSettingForm/>}/>
                <Route path="*" element={<Error404/>}/>
            </Route>
        </Routes>
    );
};

TimeKeepingSettingRouter.propTypes = {};

export default TimeKeepingSettingRouter;